<div edsGrid *ngIf="loadChart">
  <div edsRow>
    <div edsCol>
      <div edsSpacing="md"></div>

      <eds-proximal placement="ShadowNavProximalPlacementTop"></eds-proximal>

      <eds-section-header
        [title]="
          'products.price-shadow-nav-section-title'
            | translate: brConfig?.fundId
        "
        [level]="6"
        [asOfLabel]="'products.as-of' | translate"
        [asOfDate]="chartAsOfDate"
        edsSpacing="md"
        caveatPlacement="Historical Shadow Nav:6MonthHistoricalShadowNAV"
      ></eds-section-header>
    </div>
  </div>

  <div edsRow>
    <div edsCol>
      <highcharts-chart
        *ngIf="highcharts"
        [Highcharts]="highcharts"
        [options]="chartOptions"
        style="width: 100%; height: 400px; display: block"
      ></highcharts-chart>

      <eds-proximal placement="ShadowNavProximalPlacementBottom"></eds-proximal>
    </div>
  </div>
</div>
